// extracted by mini-css-extract-plugin
export default {"iata":"UBqrS","additionalInfo":"QygS5","transparent":"vWFBf","AirportIcon":"WPRLG","RailwaysIcon":"b0mhM","HotelsIcon":"_5u5dS","MapPointIcon":"PnklW","skeleton-progress":"_3KC1U"};